import { useQuery } from '@apollo/client';

import { notEmpty } from '@crehana/utils';

import GET_AVAILABLE_RESOURCE_CATEGORIES from '../graphql/GetAvailableResourceCategories.graphql';
import {
  GetAvailableResourceCategories,
  GetAvailableResourceCategoriesVariables,
} from '../graphql/types/GetAvailableResourceCategories';

const useAvailableResourceCategories = ({
  typeResource,
}: {
  typeResource: string;
}) => {
  const { data } = useQuery<
    GetAvailableResourceCategories,
    GetAvailableResourceCategoriesVariables
  >(GET_AVAILABLE_RESOURCE_CATEGORIES, {
    variables: {
      typeResource,
    },
  });

  const categories = data?.categoriesForResources?.filter(notEmpty) || [];

  return { categories };
};

export default useAvailableResourceCategories;
